// extracted by mini-css-extract-plugin
export var messageSideLeft = "_p3-1";
export var messageSideRight = "_p3-2";
export var subscribeToBackInStockBubbleContainer = "_p3-0";